export default __webpack_public_path__ + "static/Intercom-895dfda1de5c001b3d4b2046c9b1cd46.png";